import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
//Limitless imports
import DialogueBody from "../../dialogue-body/DialogueBody";
import ExpertDialogueWrapper from "../expert-dialogue-wrapper/ExpertDialogueWrapper";
import AttachmentBody from "../../attachment-body/AttachmentBody";
import TimePosted from "../../time-posted/TimePosted";
const useStyles = makeStyles({
  dialogueContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  }
});
const ExpertAttachmentDialogue = ({
  dialogue,
  shouldAnimate,
  isReported,
  showExpertThumbnail,
  message
}) => {
  const classes = useStyles();
  const {
    author,
    body,
    created,
    attachments,
    userId
  } = dialogue;
  const expertInfo = message.expertAuthors[userId];
  if (!showExpertThumbnail && expertInfo) {
    expertInfo.thumbnail = null;
  }
  const hasBody = typeof body === "string";
  return /*#__PURE__*/React.createElement(ExpertDialogueWrapper, {
    shouldAnimate: shouldAnimate,
    author: author,
    expertInfo: expertInfo
  }, expertClasses => {
    return /*#__PURE__*/React.createElement("div", {
      className: hasBody ? classes.dialogueContainer : ""
    }, /*#__PURE__*/React.createElement("div", null, attachments && attachments.map((attachment, index) => {
      return /*#__PURE__*/React.createElement("div", {
        key: index
      }, /*#__PURE__*/React.createElement(AttachmentBody, {
        backgroundStyle: expertClasses.expertBackground,
        textStyling: isReported ? expertClasses.blurText : expertClasses.expertText,
        attachment: attachment
      }));
    })), typeof body === "string" && /*#__PURE__*/React.createElement("div", {
      className: `${expertClasses.listItem} ${expertClasses.expertBackground}`
    }, /*#__PURE__*/React.createElement(DialogueBody, {
      body: body,
      textStyling: isReported ? expertClasses.blurText : expertClasses.expertText,
      linkify: !isReported
    })), created && /*#__PURE__*/React.createElement("div", {
      className: expertClasses.responseTime
    }, /*#__PURE__*/React.createElement(TimePosted, {
      time: created
    })));
  });
};
export default ExpertAttachmentDialogue;
ExpertAttachmentDialogue.propTypes = {
  dialogue: PropTypes.object.isRequired,
  shouldAnimate: PropTypes.bool.isRequired,
  isReported: PropTypes.bool,
  showExpertThumbnail: PropTypes.bool,
  message: PropTypes.object.isRequired
};
ExpertAttachmentDialogue.defaultProps = {
  isReported: false,
  showExpertThumbnail: true
};